import React from 'react';
import { toneDot } from '../ui/Badge';
import { actionTone } from './gpsCalendarTones.js';

const GPSCalendarEventChip = ({ event }) => {
  const tone = actionTone(event?.extendedProps?.issue?.request_type);
  return (
    // The type sits at the truncated end of the label; the tooltip gives it back in full.
    <span
      title={event?.title}
      className="flex items-center gap-1.5 w-full px-1.5 py-1 rounded-md text-[11px] leading-tight
                 cursor-pointer transition-colors hover:bg-gray-100 dark:hover:bg-gray-700/60"
    >
      <span
        className="w-1.5 h-1.5 rounded-full flex-shrink-0"
        style={{ background: toneDot(tone) }}
        aria-hidden
      />
      <span className="truncate text-gray-700 dark:text-gray-200">{event?.title}</span>
    </span>
  );
};

export default GPSCalendarEventChip;
